// Older Android WebViews need standard-library features before App modules initialize.
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import "./publicSite.css";
import "./styles/workspace.css";
import "./styles/selects.css";

// âœ… Import de la config i18n
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
